import React from 'react'
import GlobalReach from '../Components/GlobalReach'
import ProductOffering from '../Components/ProductOffering'
import Testimonial from '../Components/Testimonial'
import Assembly from '../Components/Assembly'
import Team from '../Components/Team'
import JoinTeam from '../Components/JoinTeam'
import Gallery from '../Components/Gallery'
import Contact from '../Components/Contact'
import LogoSwiper from '../Components/LogoSwiper'
import ProductHome from '../Components/ProductComponents/ProductHome'
import ProductFeature from '../Components/ProductComponents/ProductFeature'
import ProductTestimonial from '../Components/ProductComponents/ProductTestimonial'



const Product = () => {

  return (
    <div className='productPageSection'>
        <ProductHome/>
        <ProductFeature/>
        <ProductTestimonial/>
    </div>
  )
}

export default Product